/**
 * EWmail
 */
 export const EmailChange = (function () {

  var init =  function () {
    addEventListeners();    
  }
  /**
   * EVENT LISTENER FUNCTIONS
   */
  function addEventListeners() {
    // Onclick on the submit button
    $('.myds-email-change').each(function () {
      $(this).find('form').on('submit',function (event) {
          // Stop the form submitting
          event.preventDefault();
          event.stopPropagation();

          // Get the data-id of the form - if not exist stop, we need the ID
          EmailChange.id = this.getAttribute('data-id');
          if(! EmailChange.id) { throw Error(`No id supplied for email-change component ${ EmailChange.id}`);}

          var form = this;

          // Validate the result and stop 
          if(!validate(this)){
            return;
          }
          // Change the email and display the result
          var inputs = getInputs( );
          var promise = patchChangeEmail( inputs  );
          promise.then(function () {
              Util.toggleAlert('.alert', "Success: Email Changed!", 'alert-success');
              resetForm(form, inputs.new_email);
          });
          promise.fail(function (response) {
              var message = (response.responseJSON != undefined) ? response.responseJSON['message'] : 'There was an error while processing this request.';
              Util.toggleAlert('.alert', message , 'alert-warning');
          });          
      });
    });

    // Toggles between showing and hiding email
    $(".myds-change-email--show-hide-password a").on('click', function (event) {
      event.preventDefault();
      // Toggles both new email and confirm email inputs as both have the new-confirm-email class
      $('.myds-change-email-eye').toggleClass('fa-eye-slash fa-eye');
      var $password =  $('.myds-change-email--show-hide-password input');
      if ($password.attr('type') === 'password') {
        $password.attr('type', 'text');
      } else {
        $password.attr('type', 'password');
      }
    });
  }
  /**
   * HTTP FUNCTIONS
   */
  function patchChangeEmail( data ) {
      
      var csrf = Util.getCSRF();
      return $.ajax({
        url: `/email/change`,
        type: 'patch',
        dataType: 'json',
        headers: {
          'x-csrf-token': csrf
        },
        data: data,
      });
  }
  /**
   * HELPER FUNCTIONS
   */
  /**
   * Validate the email reset form using the HTML Constraint API
   * @param {*} form 
   * @returns 
   */
  function validate( form ) {

    // Remove the was-validated class if it existed on the form.  This will clear the validatoin back to a blank slate
    $(form).removeClass('was-validated');
    
    var newemail = document.getElementById(`myds-change-email-input-${EmailChange.id}`);
    var password = document.getElementById(`myds-change-email-password-input-${EmailChange.id}`);
    var newemailInfo = document.getElementById(`myds-email-change-currentemailinfo-${EmailChange.id}`);
    var passwordInfo = document.getElementById(`myds-email-change-currentemailinfo-${EmailChange.id}`);
   
    // Check there are values and the min lengh is > 8
    // Not it should be possible to induvidually check constraints 
    var  isValid = true;

    if ( newemail.validity.valueMissing ) {
      newemail.classList.add('is-invalid');
      isValid = false;
    }
    if ( password.validity.valueMissing ) {
      password.classList.add('is-invalid');
      isValid = false;
    }
    
    $(form).toggleClass('was-validated');
    return isValid;
  }

  function getInputs( ) {
    
    // Get the values form the form
    var newmail = document.getElementById(`myds-change-email-input-${EmailChange.id}`).value;
    var password = document.getElementById(`myds-change-email-password-input-${EmailChange.id}`).value;

    return {
      'new_email' : newmail,
      'password' : password
    }
  }
  function resetForm( form,email ) {
    
    // Get the values form the form
    document.getElementById(`myds-change-email-input-${EmailChange.id}`).value = "";
    document.getElementById(`myds-change-email-password-input-${EmailChange.id}`).value = "";
    document.getElementById(`myds-account-email-input`).innerHTML = email;
    $(form).removeClass('was-validated');

  }

  return {
    init: init
  }
}());
